import cn from 'client/utils/cn';
import LangContext from 'client/utils/lang-context';

import { PressReleaseItemData } from 'client/bundles/types';

import Date from 'client/components/date';

import React, { Component } from 'react';

import './index.css';

const b = cn('press-release-item');

interface Props {
    release: PressReleaseItemData;
}

class PressReleaseItem extends Component<Props> {
    static contextType = LangContext;

    render() {
        const { release } = this.props;

        if (!release) {
            return null;
        }

        return (
            <div className={b()}>
                <a
                    className={b('link')}
                    href={release.url}
                    >
                    <Date dateStart={release.date} />

                    <span className={b('title')}>
                        {release.title}
                    </span>
                </a>
            </div>
        );
    }

}

export default PressReleaseItem;
